import { tv, VariantProps } from "@/utils";

export const input = tv({
  slots: {
    base: ["relative", "w-full", "flex flex-col"],
    label: ["mb-2"],
    group: ["relative", "flex items-center gap-x-2"],
    input: [
      "block",
      "w-full",
      "uppercase font-roboto font-semibold tracking-widest",
      "py-4 px-0",
      "appearance-none",
      "outline-none focus:outline-none focus:ring-0",
      "border-0 border-b-gray-900 border-b",
      "text-sm",
    ],
  },
  variants: {
    color: {
      dark: {
        base: ["text-primary-100"],
        label: ["text-primary-100"],
        input: ["text-primary-100 placeholder:text-gray-100"],
      },
      light: {
        base: ["text-secondary-600"],
        label: ["text-secondary-600"],
        input: ["text-primary-500 placeholder:text-gray-400"],
      },
    },
    hasError: {
      true: {
        input: ["border-red-500", "text-red-500 placeholder:text-red-400"],
      },
    },
  },
  compoundSlots: [
    {
      slots: ["label", "input"],
      hasError: true,
      className: "text-red-500",
    },
  ],
  defaultVariants: {
    color: "dark",
    hasError: false,
  },
});

export type InputVariantProps = VariantProps<typeof input>;

export type InputReturnVariantProps = ReturnType<typeof input>;
